<script setup lang="ts">
defineProps<{ placeholder?: string; rows?: number; invalid?: boolean; mono?: boolean; disabled?: boolean }>();
const model = defineModel<string | null>({ default: '' });
</script>

<template>
  <textarea
    v-model="model"
    class="textarea"
    :class="{ 'is-invalid': invalid, mono }"
    :rows="rows ?? 3"
    :placeholder="placeholder"
    :disabled="disabled"
  />
</template>

<style scoped>
.textarea {
  width: 100%;
  resize: vertical;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 8px 10px;
  outline: none;
  line-height: 1.5;
  transition:
    border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.textarea:hover {
  border-color: var(--border-strong);
}
.textarea:focus {
  border-color: var(--accent);
  box-shadow: var(--focus);
  background: var(--surface);
}
.textarea.is-invalid {
  border-color: var(--danger);
}
.textarea.mono {
  font-family: var(--font-mono);
  font-size: 12.5px;
}
.textarea::placeholder {
  color: var(--faint);
}
</style>
